import Store from 'store/store';
import * as actions from 'store/actions';

export function requestCameraAccess(facingUser = true, stopStreamImmediately = true) {
	navigator.mediaDevices.getUserMedia =	navigator.mediaDevices.getUserMedia ||
											navigator.mediaDevices.webkitGetUserMedia ||
											navigator.mediaDevices.mozGetUserMedia ||
											navigator.mediaDevices.msGetUserMedia || {};

	if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
		navigator.mediaDevices.getUserMedia({ video: { facingMode: facingUser ? 'user' : 'environment' } })
			.then((stream) => {
				if (stopStreamImmediately) {
					stopStream(stream);
				}
				Store.emit(actions.CAMERA_ACCESS_GRANTED, stream);
			})
			.catch((e) => {
				if (e.message?.includes('denied')) {
					Store.emit(actions.CAMERA_ACCESS_DENIED, 'camera');
				} else {
					Store.emit(actions.CAMERA_ACCESS_DENIED, 'device-error');
				}
			});
	}
}

export function stopStream(stream) {
	const tracks = stream?.getTracks();
	tracks?.forEach(track => {
		track.stop();
	});
}